<template>
  <Modal :id="'cpm-add-contact-modal'" @cancelled="onCancel">
    <template slot="header">New Contact</template>

    <template slot="body">
      <!-- <span>c{{ company }} p{{ person }}</span> -->
      <div class="contact-type-selection">
        <div class="contact-type">
          <input
            type="radio"
            :checked="contactType == 'person'"
            @change="(e) => onChangeContactType('person')"
            value="person"
            name="contact"
          />
          <label for="contact" @click="(e) => onChangeContactType('person')"> {{ $t('person') }} </label>
        </div>
        <div class="contact-type">
          <input
            type="radio"
            :checked="contactType == 'company'"
            @change="(e) => onChangeContactType('company')"
            value="company"
            name="contact"
          />
          <label for="contact" @click="(e) => onChangeContactType('company')">{{ $t('company') }}</label
          >
        </div>
      </div>
      <div class="fform-group">
        <div class="person-controls form-group" v-if="contactType == 'company'">
          <TextField
            class="m1"
            :id="'companyName'"
            required
            v-bind="textFieldConfig"
            :value="company.companyName"
            :placeholder="$t('company')"
            @valuechanged="onTextFieldValueChange"
            @validated="onCompanyValidation"
          />
          <TextField
            class="m1"
            :id="'city'"
            v-bind="textFieldConfig"
            :value="company.city"
            :placeholder="$t('city')"
            @valuechanged="onTextFieldValueChange"
            @validated="onCompanyValidation"
          />
          <Dropdown
            :options="countries || []"
            :selected="
              (countries || []).find((c) => c.value == company.country)
            "
            class="m2"
            :placeholder="$t('country')"
            v-on:selectedChange="(e) => onCountryChange(e)"
            :listHeight="128"
            box
          />
          <Dropdown
            :options="groups || []"
            class="m2"
            :selected="
              (groups || []).filter((g) =>
                (company.groups || []).map((pg) => pg.value).includes(g.value)
              ) || []
            "
            :placeholder="$t('add_to_group_optional')"
            v-on:selectedChange="(e) => onGroupChange(e)"
            box
            multiple
            :listHeight="128"
            :maxSelection="3"
          ></Dropdown>
        </div>
        <div class="person-controls form-group" v-if="contactType == 'person'">
          <TextField
            class="m1"
            :id="'firstName'"
            required
            v-bind="textFieldConfig"
            :value="person.firstName"
            :placeholder="$t('first_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'lastName'"
            required
            v-bind="textFieldConfig"
            :value="person.lastName"
            :placeholder="$t('last_name')"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'email'"
            required
            v-bind="textFieldConfig"
            :value="person.email"
            :placeholder="$t('email')"
            :validators="emailValidators"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <TextField
            class="m1"
            :id="'phone'"
            v-bind="textFieldConfig"
            :value="person.phone"
            :placeholder="$t('phone')"
            :showValidationIcons="false"
            @valuechanged="onTextFieldValueChange"
            @validated="onValidation"
          ></TextField>
          <Dropdown
            :options="groups || []"
            class="sm2"
            :key="'group_dropdown_person'"
            :selected="
              (groups || []).filter((g) =>
                (person.groups || []).map((pg) => pg.value).includes(g.value)
              ) || []
            "
            :placeholder="$t('add_to_group_optional')"
            v-on:selectedChange="(e) => onGroupChange(e)"
            box
            multiple
            :listHeight="128"
            :maxSelection="3"
          ></Dropdown>
        </div>
      </div>
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 with-ico"
        :class="{ disabled: !IsFormValid }"
        :disabled="!IsFormValid"
        @click.stop="addNewContact"
      >
        <div class="dt-icon-container">
          <img src="static/icons/plus-white.svg" class="dt-icon v7" alt />
        </div>
        <div class="button-text">
          {{ $dft.capSnake($t("add_contact")) }}
        </div>
      </button>
    </template>
  </Modal>
</template>

<script>
import { createValidator } from "@plugins/text-field";

import isEmail from "validator/lib/isEmail";
import { ContactService } from "./contact.service";
import { createCountriesTV } from "../../models/country.model";
import Modal from "../../dt-plugins/modal/modal";
import { wait } from "../../utility";

export default {
  components: {
    Modal,
  },
  props: {},
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: true,
        immediateValidation: true,
      },
      groups: null,
      countries: null,
      selectedCountry: {},
      person: createPerson(),
      company: createCompany(),
      emailValidators: [
        createValidator({
          name: "emailValidation",
          validatorFn: isEmail,
          errorMessage: "Must be a valid Email",
        }),
      ],
      personValidationResult: {},
      companyValidationResult: {},
      contactType: "person",
      loading: true,
    };
  },
  mounted: function () {
    ContactService.findContactGroups().then((res) => {
      this.groups = res.data.groups.map((e) => ({
        text: e.group_name || ".",
        value: e.group_id,
      }));
      this.countries = createCountriesTV(res.data.countries);
      this.loading = false;
    });

    // setTimeout(() => {
    //   this.company = createCompany();
    //   this.person = createPerson();
    // });
  },
  computed: {
    IsFormValid: function () {
      // return true;
      // console.log(this.companyValidationResult);
      return this.contactType === "company"
        ? Object.values(this.companyValidationResult).every((e) => e.valid)
        : Object.values(this.personValidationResult).every((e) => e.valid);
    },
    selectedPersonGroups: function () {
      return this.person.groups;
    },
    selectedCompanyGroups: function () {
      return this.company.groups;
    },
  },
  methods: {
    checkCity(value) {
      ContactService.checkCity({ city: value }).then((res) => {
        this.countries = createCountriesTV(res.data.countries);
        this.company.country =
          this.countries && this.countries.length > 0
            ? this.countries[0].value
            : "";
      });
    },
    onTextFieldValueChange: function (key, value) {
      if (this.contactType === "person") {
        this.person[key] = value;
      } else if (this.contactType === "company") {
        this.company[key] = value;
        if (key === "city") {
          this.checkCity(value);
        }
      }
    },
    onValidation: function (name, value) {
      // console.log("per validate", { name, value });
      this.$set(this.personValidationResult, name, value);
    },
    onCompanyValidation: function (name, value) {
      // console.log("com validate", { name, value });
      this.$set(this.companyValidationResult, name, value);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    onCountryChange: function (value) {
      this.company.country = value.value;
    },
    addNewContact: function (e) {
      this.$emit("new_contact", {
        type: this.contactType,
        contact: this.contactType === "person" ? this.person : this.company,
      });
      this.loading = true;
    },
    onChangeContactType: async function (type) {
      this.contactType = type;
      this.company = {};
      this.person = {};

      await wait(20);

      this.company = createCompany();
      this.person = createPerson();

      // console.log({
      //   company: this.company,
      //   person: this.person,
      // });
    },
    onGroupChange: function (value) {
      if (this.contactType === "person") {
        this.person.groups = value;
        this.person["group_id1"] =
          this.person.groups[0] && this.person.groups[0].value;
        this.person["group_id2"] =
          this.person.groups[1] && this.person.groups[1].value;
        this.person["group_id3"] =
          this.person.groups[2] && this.person.groups[2].value;
      } else if (this.contactType === "company") {
        this.company.groups = value;
        this.company["group_id1"] =
          this.company.groups[0] && this.company.groups[0].value;
        this.company["group_id2"] =
          this.company.groups[1] && this.company.groups[1].value;
        this.company["group_id3"] =
          this.company.groups[2] && this.company.groups[2].value;
      }

      // console.log({
      //   personGr: this.person.groups,
      //   companyGr: this.company.groups,
      // });
    },

    //MARK: Methods
  },
};

const createPerson = ({
  firstName = "",
  lastName = "",
  email = "",
  phone = "",
  groups = [],
} = {}) => {
  return {
    firstName,
    lastName,
    email,
    phone,
    groups,
  };
};

const createCompany = ({
  companyName = "",
  city = "",
  country = "",
  groups = [],
} = {}) => {
  return {
    companyName,
    city,
    country,
    groups,
  };
};
</script>

<style lang="scss">
.cpm-add-contact-modal {
  .form-group {
    display: flex;
    flex-direction: column;

    // .dt-input-box--container {
    //   flex: 1;
    //   margin: 5px 0px;
    //   margin-left: 0px;
    // }

    .group-input {
      // margin-top: 25px;
      // margin-bottom: 10px;
      // margin-right: 5px;

      min-height: 42px;
    }
  }

  .person-controls,
  .company-controls {
    height: 249px;
  }

  .dt-modal--options {
    display: flex;
    justify-content: flex-end;
    button {
      flex: 1;
      &:first-child {
        margin-right: 10px;
      }
      &:last-child {
        margin-left: 10px;
      }
    }
  }
}

// Contact Type Selection Global CSS

// #GlobalCSS
.contact-type-selection {
  display: flex;
  flex-direction: column;
  padding: 0px;
  margin-bottom: 10px;
  .contact-type {
    flex: 1;
    display: flex;
    margin: 4px 0px;

    input {
      margin: auto 0;
    }
    label {
      margin-left: 10px;
      cursor: pointer;
    }
  }
}
</style>
